import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router'
import store from './store'
import filters from './filters'
import api from './api'
import directives from './directives'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


FastClick.attach(document.body)

Vue.use(WechatPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)

Vue.config.productionTip = false
Vue.UPLOAD_DOMAIN = Vue.prototype.UPLOAD_DOMAIN = process.env.UPLOAD_DOMAIN

new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box');



// WEBPACK FOOTER //
// ./src/main.js